<template>
  <v-menu
    :attach="attach"
    v-model="computedValue"
    v-on="$listeners"
    :absolute="isAbsolute"
    :offset-y="offsetY"
    :offset-x="offsetX"
    transition="scroll-y-transition"
    :close-on-content-click="closeOnContentClick"
  >
    <template #activator="{ on, attrs }">
      <slot name="activator" v-bind="{ on, ...$props, attrs }">
        <base-button type="text" :size="size" icon="mdi-dots-vertical" v-on="on" :tooltip="$i18n.t('button.options')" />
      </slot>
    </template>
    <v-list style="min-width: 135px">
      <slot name="top-item"> </slot>
      <template v-for="item in items">
        <slot :name="`${item.name}.title`">
          <v-tooltip bottom color="font" :key="getItemKey(item)" :disabled="!item.tooltip">
            <template #activator="{ on }">
              <span v-on="on">
                <v-list-item
                  style="min-height: 30px"
                  :key="item.id || item.name"
                  v-on="getListeners(item)"
                  @click="$emit('selectedItem', item.name, item)"
                  :disabled="item.disabled"
                  v-if="exactItems"
                >
                  <v-list-item-title
                    class="text-item text-left text-subtitle-2 font-weight-regular"
                    v-text="item.name"
                  />
                </v-list-item>
                <dots-menu v-if="item.customItems" :items="item.customItems" :offset-x="true" :offset-y="false">
                  <template #activator="{ on }">
                    <v-list-item style="min-height: 30px" v-on="on">
                      <v-list-item-title
                        class="text-item text-left text-subtitle-2 font-weight-regular"
                        v-text="item.customName || $i18n.t(`menu.${item.name}`, item.params)"
                      />
                    </v-list-item>
                  </template>
                </dots-menu>
                <v-list-item
                  style="min-height: 30px"
                  :key="item.name"
                  @click="item.customAction ? item.customAction() : $emit(item.name)"
                  v-else
                  :disabled="item.disabled"
                >
                  <v-list-item-title
                    class="text-item text-left text-subtitle-2 font-weight-regular"
                    v-text="item.customName || $i18n.t(`menu.${item.name}`, item.params)"
                  />
                </v-list-item>
              </span>
            </template>
            {{ item.tooltip }}
          </v-tooltip>
        </slot>
        <slot :name="item.name" />
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'DotsMenu',
  props: {
    value: {
      type: Boolean,
      default: undefined,
    },
    items: {
      type: Array,
      required: true,
    },
    closeOnContentClick: {
      type: Boolean,
      default: true,
    },
    exactItems: {
      type: Boolean,
      default: false,
    },
    isAbsolute: {
      type: Boolean,
      default: false,
    },
    attach: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'base',
    },
    offsetY: {
      type: Boolean,
      default: true,
    },
    offsetX: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    getListeners(item) {
      return Object.keys(this.$listeners).reduce((total, key) => {
        return {
          ...total,
          [key]: () => {
            this.$emit(key, item);
          },
        };
      }, {});
    },
    getItemKey(item) {
      return `${this.$_getHash(item.name + (item.params ? JSON.stringify(item.params) : ''))}_tooltip`;
    },
  },
};
</script>

<style lang="scss" scoped></style>
